module.exports = __webpack_public_path__ + "static/media/logo.1b0bb427.png";